import { t } from 'i18next';

export const MainCategoricalGroup2GoodsUnionPluginSettings = (): IPluginSettings => {
    let index = 0
    return {
        name: t('directory.categoricalGroup.MainCategoricalGroup2GoodsUnionPluginSettings.gridPluginName'),
        mnemocode: "main_categorical_group_2Goods_union_plugin",
        permission: "CategoricalGroup",
        columns: [
             {
                order: index++,
                propertyName: "idGlobal",
                propertyType: "string",
                displayName: t('directory.categoricalGroup.MainCategoricalGroup2GoodsUnionPluginSettings.idGlobal'),
                visibility: false,
                width: 160,
            },
            {
                order: index++,
                propertyName: "goodsCode",
                propertyType: "string",
                displayName: t('directory.categoricalGroup.MainCategoricalGroup2GoodsUnionPluginSettings.goodsCode'),
                visibility: true,
                width: 160,
            },
            {
                order: index++,
                propertyName: "goodsName",
                propertyType: "string",
                displayName: t('directory.categoricalGroup.MainCategoricalGroup2GoodsUnionPluginSettings.goodsName'),
                visibility: true,
                width: 360,
            },
        ],
    }
};
